<template>
  <div class="pub-collapse">
    <p class="collapse-title" @click="changeIcon">
      <i class="layui-icon">&#xe63c;</i>
      <span>{{title}}</span>
      <i class="layui-icon collapseIcon roate" v-show="!showHide">&#xe623;</i>
      <i class="layui-icon collapseIcon" v-show="showHide">&#xe625;</i>
    </p>
    <div v-show="showHide" class="collapse-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    showHide : {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
    }
  },
  methods: {
    changeIcon () {
      this.showHide = !this.showHide
    }
  }
}
</script>

<style scoped>
.collapse-title {
  position: relative;
  font-size: 20px;
  color: #00A0E9;
  margin-bottom: 20px;
  cursor: pointer;
  /* padding: 0px 20px; */
}
/* .collapse-content {
  padding: 0px 20px;
} */
.layui-icon {
  font-size: 20px;
}
.collapseIcon {
  display: inline-block;
  position: absolute;
  right: 12px;
}
.roate {
 transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/common/pub-collapse.vue